import React, { Component } from "react";
import ReactTags from "react-tag-autocomplete";
import { components, Creatable } from "react-select";
import { observer } from "mobx-react";
import _ from "lodash";
import { isMobile } from "components/ReactUtils/mobileDetect";

import theme from "components/theme";

const IndicatorSeparator = () => null;

const DropdownIndicator = () => null;

const Control = ({ children, ...props }) => (
  <components.Control {...props} className="react-select_control">
    {children}
  </components.Control>
);

const Input = ({ children, ...props }) => (
  <components.Input {...props} className="react-select_input">
    {children}
  </components.Input>
);

class InputTags extends Component {
  state = { query: "" };

  handleDelete = i => {
    const { store, name, handleDelete } = this.props;
    const tags = store.get(name);
    store.setArray(
      name,
      tags.filter((tag, index) => index !== i)
    );

    handleDelete && handleDelete(i);
  };

  handleAddition = tag => {
    if (!tag || !tag.name || tag.name.trim() === "") return;

    const { store, name, handleAddition } = this.props;
    const tags = store.get(name);
    if (tags) {
      tags.push(tag);
      store.setArray(name, tags);
    } else {
      store.setArray(name, [tag]);
    }

    handleAddition && handleAddition(tag);

    this.setState({ query: "" });
  };

  handleInputChange = query => {
    this.setState({ query });
  };

  handleBlur = () => {
    const { query } = this.state;
    const { allowNew } = this.props;

    if (allowNew && query.length > 0) {
      this.handleAddition({ name: query });
      this.reactTagsRef.setState({ query: "" });
      this.setState({ query: "" });
    }
  };

  onChange = valuesArray => {
    const { store, name } = this.props;
    store.setArray(
      name,
      valuesArray.map(v => ({ id: v.value, name: v.label }))
    );
  };

  onBlur = e => {
    const { store, name } = this.props;

    const { value } = e.target;
    if (value && value.length > 0) {
      let tags = store.get(name);
      if (tags) {
        tags.push({ id: value, name: value });
        tags = _.uniqBy(tags, t => t.id);
        store.setArray(name, tags);
      } else {
        store.setArray(name, [{ id: value, name: value }]);
      }
    }
  };

  render() {
    const {
      // theme,
      name,
      label,
      id,
      // formGroupAdd,
      // additionalSelects = [],
      labelWidth = "",
      inputWidth = "",
      maxSuggestionsLength,
      allowNew,
      store,
      size = "md",
      placeholder = "",
      options = [],
      inputGroup = false,
      classNames = {
        root: "react-tags",
        rootFocused: "is-focused",
        selected: "react-tags__selected",
        selectedTag: "react-tags__selected-tag",
        selectedTagName: "react-tags__selected-tag-name",
        search: "react-tags__search",
        searchInput: "react-tags__search-input",
        suggestions: "react-tags__suggestions",
        suggestionActive: "is-active",
        suggestionDisabled: "is-disabled",
      },
      autofocus = true,
      minQueryLength = 2,
      multiSelect = false,
    } = this.props;

    const MultiValueLabel = ({ children, ...props }) => (
      <components.MultiValueLabel {...props}>
        <div
          onKeyPress={undefined}
          onClick={() => {
            const tags = store.get(name);
            store.setArray(
              name,
              tags.filter(tag => props.data.value !== tag.id)
            );
            this.select.state.inputValue = props.data.value;
          }}
        >
          {children}
        </div>
      </components.MultiValueLabel>
    );

    const inputEl = multiSelect ? (
      <Creatable
        ref={ref => {
          this.select = ref;
        }}
        isClearable={false}
        // These are removed becasue for some reason it breaks Creatable option to create new elements
        // getOptionLabel={option => option.name}
        // getOptionValue={option => option.id}
        // options={options.map(option => ({ id: option.value, name: option.label }))}
        // value={store.get(name)}
        name={name}
        options={options}
        value={store.get(name).map(option => ({ value: option.id, label: option.name }))}
        onChange={this.onChange}
        onBlur={this.onBlur}
        placeholder={placeholder}
        formatCreateLabel={input => input}
        openMenuOnFocus
        openMenuOnClick={false}
        createOptionPosition="first"
        isSearchable
        noOptionsMessage={() => "Keine Ergebnisse für"}
        autoFocus={false}
        styles={{
          control: base => ({
            ...base,
            border: `1px solid ${theme.colors.gray}`,
          }),
        }}
        isMulti
        // blurInputOnSelect
        data={store && store.data}
        theme={baseTheme => ({
          ...baseTheme,
          spacing: {
            ...baseTheme.spacing,
            controlHeight: 45,
            baseUnit: 2,
            menuGutter: 4,
          },
          colors: {
            ...baseTheme.colors,
            primary: theme.colors.primary,
            primary25: theme.colors.primarySecond,
          },
        })}
        components={{ MultiValueLabel, DropdownIndicator, IndicatorSeparator, Control, Input }}
      />
    ) : (
      <ReactTags
        ref={ref => (this.reactTagsRef = ref)}
        tags={store.get(name)}
        classNames={classNames}
        suggestions={options.map(option => ({ id: option.value, name: option.label }))}
        handleDelete={this.handleDelete}
        handleInputChange={this.handleInputChange}
        handleBlur={this.handleBlur}
        placeholder={placeholder}
        handleAddition={this.handleAddition}
        minQueryLength={minQueryLength}
        maxSuggestionsLength={maxSuggestionsLength}
        allowNew={allowNew}
        autofocus={autofocus}
        data={store && store.data}
      />
    );

    return (
      <div
        className={[
          "inputText",
          // animatedLabelAbove && "animatedLabelAbove",
          // animatedLabel && "placeholderToLabel",
          // type === "textarea" && "textarea",
          // tall && "tall",
          // type === "money" && "money",
          // focus && "focus",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div
          className={[inputGroup && !isMobile() && "input-group", "position-relative", `input-group-${size}`]
            .filter(Boolean)
            .join(" ")}
        >
          {label && (
            <label
              htmlFor={id}
              onClick={() => this.input.focus()}
              className={[
                "control-label",
                labelWidth,
                // animatedLabelUp ? "labelActive" : "labelUnactive",
              ].join(" ")}
            >
              <span className="labelText">{label || name}</span>
            </label>
          )}

          {!inputGroup && <div className={`inputTags ${inputWidth}`}>{inputEl}</div>}
          {inputGroup && inputEl}
        </div>

        {store && store.errors && store.errors[name] && (
          <p className="error">
            <small>{store.errors[name][0]}</small>
          </p>
        )}
      </div>
    );
  }
}

InputTags = observer(InputTags);

export default InputTags;
